import React from 'react';

const Adjust = ({ className }) => {
    return (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="6.5" cy="6.5" r="5.5" stroke="white" />
            <path d="M12 6.5C12 9.53757 9.53757 12 6.5 12C3.46243 12 1 9.53757 1 6.5C6.5 6.5 3.46243 6.5 6.5 6.5C9.53757 6.5 6.5 6.50015 12 6.5Z" fill="white" />
        </svg>
    )
}

export default Adjust;